/* eslint-disable no-shadow */
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

export interface AppControllerType {
  common: BreadcrumbsRoute[];
  drawer: BreadcrumbsRoute[];
}

export enum AppRouterTypes {
  Common = 'common',
  Drawer = 'drawer'
}

export enum AppRoutes {
  Home = '/',

  Sites = '/sites',
  SitesCreate = '/sites/create',
  SitesById = '/sites/view/:siteId',
  SitesEdit = '/sites/view/:siteId/edit',
  SitesDossier = '/sites/view/:siteId/dossier',
  SitesFSManager = '/sites/view/:siteId/static-fs-manager',
  SiteDomains = '/sites/view/:siteId/domains',
  SiteDomainsById = '/sites/view/:siteId/domains/:domainId',
  SitesDomainsByIdRegluing = '/sites/view/:siteId/domains/:domainId/regluing',

  SitesTemplates = '/sites/view/:siteId/templates',

  SitesCriticalCss = '/sites/view/:siteId/critical-css',

  SiteGroups = '/site-groups',
  SiteGroupsCreate = '/site-groups/create',
  SiteGroupsById = '/site-groups/view/:siteGroupId',
  SiteGroupsByIdEdit = '/site-groups/view/:siteGroupId/edit',

  Pages = '/sites/view/:siteId/pages',
  PageNodes = '/sites/view/:siteId/structure',
  PageNodesById = '/sites/view/:siteId/structure/:nodeId',
  PageNodesCreate = '/sites/view/:siteId/structure/:nodeId/create',
  PageNodesByIdEdit = '/sites/view/:siteId/structure/:nodeId/edit',
  PagesById = '/sites/view/:siteId/pages/:pageId',
  PagesEdit = '/sites/view/:siteId/pages/:pageId/edit',
  PagesCreate = '/sites/view/:siteId/pages/create/:nodeId',

  PageLayouts = '/sites/view/:siteId/templates/layouts',
  PageLayoutsCreate = '/sites/view/:siteId/templates/layouts/create',
  PageLayoutsById = '/sites/view/:siteId/templates/layouts/:layoutId',
  PageLayoutsByIdEdit = '/sites/view/:siteId/templates/layouts/:layoutId/edit',

  PageComponents = '/sites/view/:siteId/templates/components',
  PageComponentsCreate = '/sites/view/:siteId/templates/components/create',
  PageComponentsById = '/sites/view/:siteId/templates/components/:componentId',
  PageComponentsByIdEdit = '/sites/view/:siteId/templates/components/:componentId/edit',

  Domains = '/domains',
  DomainsCreate = '/domains/create',
  DomainsEdit = '/domains/:domainId/edit',
  DomainsById = '/domains/:domainId',
  DomainsByIdConfigAttach = '/domains/:domainId/deployment/attach',
  DomainsByIdConfigEdit = '/domains/:domainId/deployment/edit',

  DomainRegistrars = '/domain-registrars',
  DomainRegistrarsCreate = '/domain-registrars/create',
  DomainRegistrarsById = '/domain-registrars/:domainRegistrarId',

  Robots = '/sites/view/:siteId/robots',
  RobotsById = '/sites/view/:siteId/robots/:domainId',

  Sitemap = '/sites/view/:siteId/sitemap',
  SitemapById = '/sites/view/:siteId/sitemap/:domainId',

  SiteSearchConsole = '/sites/view/:siteId/search-console',

  SiteSearchConsoleSitemap = '/sites/view/:siteId/search-console/sitemap',
  SiteSearchConsoleSitemapById = '/sites/view/:siteId/search-console/sitemap/:domainId',

  SiteSearchConsoleSearchAnalytics = '/sites/view/:siteId/search-console/search-analytics',
  SiteSearchConsoleSearchAnalyticsById = '/sites/view/:siteId/search-console/search-analytics/:domainId',

  SiteSearchConsoleSearchUrlInspection = '/sites/view/:siteId/search-console/url-inspection',
  SiteSearchConsoleSearchUrlInspectionById = '/sites/view/:siteId/search-console/url-inspection/:domainId',

  Hostings = '/hostings',
  HostingsCreate = '/hostings/create',
  HostingsById = '/hostings/:hostingId',

  ProxyServers = '/proxy-servers',
  ProxyServersCreate = '/proxy-servers/create',
  ProxyServersById = '/proxy-servers/:proxyServerId',
  ProxyServersByIdEdit = '/proxy-servers/:proxyServerId/edit',

  DomainsApi = '/domains-api',

  DomainsApiCloudflare = '/domains-api/cloudflare',
  DomainsApiCloudflareAccounts = '/domains-api/cloudflare/accounts',
  DomainsApiCloudflareAccountsById = '/domains-api/cloudflare/accounts/:cloudflareAccountId',
  DomainsApiCloudflareAccountsCreate = '/domains-api/cloudflare/accounts/create',
  DomainsApiCloudflareAccountsEdit = '/domains-api/cloudflare/accounts/:cloudflareAccountId/edit',

  DomainsApiSearchConsole = '/domains-api/search-console',
  DomainsApiSearchConsoleAccounts = '/domains-api/search-console/accounts',
  DomainsApiSearchConsoleAccountsById = '/domains-api/search-console/accounts/:searchConsoleAccountId',
  DomainsApiSearchConsoleAccountsCreate = '/domains-api/search-console/accounts/create',
  DomainsApiSearchConsoleAccountsCreateCreds = '/domains-api/search-console/accounts/create/:searchConsoleAccountId/credentials',
  DomainsApiSearchConsoleAccountsCreateOauth2 = '/domains-api/search-console/accounts/create/:searchConsoleAccountId/oauth2',
  DomainsApiSearchConsoleAccountsEdit = '/domains-api/search-console/accounts/:searchConsoleAccountId/edit',
  DomainsApiSearchConsoleAccountsEditCreds = '/domains-api/search-console/accounts/:searchConsoleAccountId/edit/credentials',

  DnsRecords = '/dns-records',
  DnsRecordsCreate = '/dns-records/create',
  DnsRecordsEdit = '/dns-records/edit/:dnsRecordId',
  DnsRecordsById = '/dns-records/:dnsRecordId',

  Login = '/login',

  Referrals = '/sites/view/:siteId/referrals',
  ReferralsCreate = '/sites/view/:siteId/referrals/create',
  ReferralsById = '/sites/view/:siteId/referrals/:referralId',
  ReferralsEdit = '/sites/view/:siteId/referrals/:referralId/edit',

  Redirects = '/sites/view/:siteId/redirects',
  RedirectsCreate = '/sites/view/:siteId/redirects/create',
  RedirectsBulk = '/sites/view/:siteId/redirects/bulk',
  RedirectsById = '/sites/view/:siteId/redirects/:redirectId',
  RedirectsEdit = '/sites/view/:siteId/redirects/:redirectId/edit',

  ExternalRedirects = '/sites/view/:siteId/redirects/external',
  ExternalRedirectsCreate = '/sites/view/:siteId/redirects/external/create',
  ExternalRedirectsById = '/sites/view/:siteId/redirects/external/:externalRedirectId',
  ExternalRedirectsEdit = '/sites/view/:siteId/redirects/external/:externalRedirectId/edit',
}

export enum StaticRoutes {
  StaticPrefix = '/!',

  OAuth2Success = '/!/oauth2/success',
  OAuth2Failure = '/!/oauth2/failure',
}
